//# sourceMappingURL=create-pdf.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/create-pdf.interface.js
// module id = 1165
// module chunks = 4